const OBJECT_TYPES = {
    USER: 201,
    ROLE: 202,
    ENVIRONMENT: 203,
    CONFIGURATION: 204,
    DOMAIN: 205,
    SYNCLOGS: 206,
    DEPLOYMENT: 207,
    PERMISSION: 208,
    AUDIT_TRAIL: 209,
    LOGS: 210,
    ALL: 211,
    PRODUCT: 212,
    PRODUCT_SETTINGS_GROUP: 213,
    PRODUCT_SETTINGS: 214,
    PRODUCT_SETTING_TYPE: 215,
    PRODUCT_VERSION: 216,
    SETTINGS_SET: 217,
    SETTINGS_GROUPS: 218,
    SETTINGS: 219,
    CUSTOM_SETTING_TYPES: 220,
    CUSTOM_SETTING_TYPE_VALUES: 221,
    CNAME: 222,
    ENVIRONMENT_TEMPLATE: 223,
    DOMAIN_ADMIN: 9998
};

export default OBJECT_TYPES;